import { render, staticRenderFns } from "./MsDescriptions.vue?vue&type=template&id=7039b7f8&scoped=true&"
import script from "./MsDescriptions.vue?vue&type=script&lang=js&"
export * from "./MsDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./MsDescriptions.vue?vue&type=style&index=0&id=7039b7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7039b7f8",
  null
  
)

export default component.exports